export const START_OR_RESUME_SURVEY = 'START_OR_RESUME_SURVEY';
export const START_OR_RESUME_SURVEY_SUCCESS = 'START_OR_RESUME_SURVEY_SUCCESS';
export const START_OR_RESUME_SURVEY_FAILURE = 'START_OR_RESUME_SURVEY_FAILURE';

export const GET_BLOCK = 'GET_BLOCK';
export const GET_BLOCK_SUCCESS = 'GET_BLOCK_SUCCESS';

export const COMMIT_QUESTION_BLOCK = 'COMMIT_QUESTION_BLOCK';
export const COMMIT_QUESTION_BLOCK_SUCCESS = 'COMMIT_QUESTION_BLOCK_SUCCESS';
export const COMMIT_QUESTION_BLOCK_FAILURE = 'COMMIT_QUESTION_BLOCK_FAILURE';

export const COMPLETE_SURVEY = 'COMPLETE_SURVEY';

export const SUBMIT_ANSWER = 'SUBMIT_ANSWER';
export const SUBMIT_ANSWER_SUCCESS = 'SUBMIT_ANSWER_SUCCESS';



// WEBPACK FOOTER //
// ./src/actionTypes/surveyActionTypes.js